(function(){
    angular
        .module('app')
        .directive('ngInputsearch', inputSearch);

        inputSearch.$inject = ['ContentService','$timeout'];
        function inputSearch(ContentService,$timeout){
            return {
            require: 'ngModel',
            control: '=',
            focused: '=',
            optionsvalues : '=',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	console.log($attrs);
                	console.log($attrs);
                	var delay = (function(){
					  var timer = 0;
					  return function(callback, ms){
					    clearTimeout (timer);
					    timer = setTimeout(callback, ms);
					  };
					})();
					element.focus(function(){
						scope.focused[$attrs.field] = true;
					}).blur(function(){
						$timeout(function(){
							scope.focused[$attrs.field] = false;
						},200);
					}).keyup(function() {
					    delay(function(){
					    	ContentService.getContenidoCampo(scope.control.type,ngModel.$viewValue,$attrs.name.replace("_campo_",""),function(data){
								scope.optionsvalues[$attrs.field] = data.data;
	                            //console.log(data);
	                        });
					      console.log("parado");
					    }, 500 );
					});
                   console.log(ngModel);
                });
            }
          }
      }
})();